export default __webpack_public_path__ + "static/media/portfolio-wilo-2.133f88cc.jpg";